import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translationService } from '../services/translationService';
import PropTypes from 'prop-types';

const TranslationContext = createContext(undefined);

export const TranslationProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const init = async () => {
      try {
        setIsLoading(true);
        const lang = await translationService.initializeTranslations();
        setCurrentLanguage(lang);
      } catch (e) {
        console.error('Error initializing translations:', e);
      } finally {
        setIsLoading(false);
      }
    };
    init();
  }, []);

  const changeLanguage = async (lang) => {
    try {
      setIsLoading(true);
      await translationService.fetchTranslations(lang);
      setCurrentLanguage(lang);
    } catch (e) {
      console.error(`Error changing language to ${lang}:`, e);
    } finally {
      setIsLoading(false);
    }
  };

  const value = useMemo(() => ({ isLoading, currentLanguage, changeLanguage }), [isLoading, currentLanguage]);

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};

TranslationProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useAppTranslation = () => {
  const ctx = useContext(TranslationContext);
  if (ctx === undefined) {
    throw new Error('useAppTranslation must be used within a TranslationProvider');
  }
  return ctx;
};


